let routes = null;
const isLocal = process.env['REACT_APP_MODE'] === 'local';

if (isLocal) {
    routes = [
        //tenant项目  activeurl 为tenant ，在运营端就是operate/tenant，在管理端就是admin/tenant
        {
            name: 'tenant-project-operate',
            entry: '//tenant.grtcloud.net/',
            container: '#qiankun-container',
            activeRule: '/operate/tenant',
            props: {
                basename: '/operate/tenant'
            }
        },
        {
            name: 'tenant-project-admin',
            entry: '//tenant.grtcloud.net/',
            container: '#qiankun-container',
            activeRule: '/admin/tenant',
            props: {
                basename: '/admin/tenant'
            }
        },
        //admin项目  activeurl 为manage ，在运营端就是operate/manage，在管理端就是admin/manage
        {
            name: 'admin-system-operate',
            entry: '//admin.grtcloud.net/',
            container: '#qiankun-container',
            activeRule: '/operate/manage',
            props: {
                basename: '/operate/manage'
            }
        },
        {
            name: 'admin-system-admin',
            entry: '//admin.grtcloud.net/',
            container: '#qiankun-container',
            activeRule: '/admin/manage',
            props: {
                basename: '/admin/manage'
            }
        },
        {
            name: 'grt-base',
            entry: '//base.grtcloud.net/',
            container: '#qiankun-container',
            activeRule: '/admin/base'
        },

        {
            name: 'grt-app-management',
            entry: '//app.grtcloud.net/',
            container: '#qiankun-container',
            activeRule: '/operate/app',
            props: {
                basename: '/operate/app'
            }
        },
        {
            name: 'grt-evaluation-project', // app name registered
            entry: '//local.grtcloud.net/',
            container: '#qiankun-container',
            path: '/operate/evaluation',
            activeRule: '/operate/evaluation'
        }
    ];
} else {
    routes = [
        {
            name: 'tenant-project-operate',
            entry: '/tenant-alias/',
            container: '#qiankun-container',
            activeRule: '/operate/tenant',
            props: {
                basename: '/operate/tenant'
            }
        },
        {
            name: 'tenant-project-admin',
            entry: '/tenant-alias/',
            container: '#qiankun-container',
            activeRule: '/admin/tenant',
            props: {
                basename: '/admin/tenant'
            }
        },
        {
            name: 'admin-system-operate',
            entry: '/manage-alias/',
            container: '#qiankun-container',
            activeRule: '/operate/manage',
            props: {
                basename: '/operate/manage'
            }
        },
        {
            name: 'admin-system-admin',
            entry: '/manage-alias/',
            container: '#qiankun-container',
            activeRule: '/admin/manage',
            props: {
                basename: '/admin/manage'
            }
        },
        {
            name: 'grt-evaluation-project', // app name registered
            entry: '/evaluation-alias/',
            container: '#qiankun-container',
            path: '/operate/evaluation',
            activeRule: '/operate/evaluation'
        },
        {
            name: 'grt-base',
            entry: '/base-alias/',
            container: '#qiankun-container',
            activeRule: '/admin/base'
        },

        {
            name: 'grt-app-management',
            entry: '/app-management/',
            container: '#qiankun-container',
            activeRule: '/operate/app'
        }
    ];
}

export default routes;
